export default __webpack_public_path__ + "static/service-mesh-performance-8a6a32421f2cd8fba6520e2e8ff225c8.webp";